import numbro from "numbro";

export default function unformatNumber(amount) {
  return numbro.unformat(amount || 0);
}
